import {BaseComponent} from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {compose} from 'redux';
import {createStructuredSelector} from 'reselect';
import {selectUserId, selectWork} from '../../Api/selectors';
import {REQUEST_VEHICLE, REQUEST_VEHICLE_PROPERTY_UPDATE,} from '../constants';
import {Loader} from '../../../components/Loader';
import {VehicleInvoicesCard} from '../components/VehcleInvoicesCard';
import {fetchVehicleInvoices} from '../../Invoices/actions';


class VehicleDetailsColumnsComp extends BaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.fetchVehicleInvoices();
  }

  render() {
    const vehicle = this.props.vehicle;
    if (this.props.work) return <Loader small />;
    return (
      <VehicleInvoicesCard isInvoicePage vehicle={vehicle} />
    );
  }
}

VehicleDetailsColumnsComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    workVehicle: selectWork(REQUEST_VEHICLE),
    workRemarks: selectWork(`${REQUEST_VEHICLE_PROPERTY_UPDATE}-remarks`),
    loggedInUserId: selectUserId(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetchVehicleInvoices() {
      dispatch(fetchVehicleInvoices(ownProps.vehicle?.id));
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const VehicleDetailsInvoices = compose(
  withConnect,
  withRouter,
)(VehicleDetailsColumnsComp);
